<template>
    <div class="default-view">
        <h1>组件占位页</h1>
        <p>当前路由组件未配置或不存在：{{ $route.path }}</p>
    </div>
</template>

<script>
export default {
    name: 'DefaultView'
}
</script>

<style scoped>
.default-view {
    text-align: center;
    padding: 20px;
    color: #666;
}
</style>